/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cap: NonNullable<unknown> }} Chat_Dispatch_Cap_ReachedInputs */

const en_chat_dispatch_cap_reached = /** @type {(inputs: Chat_Dispatch_Cap_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cap of ${i?.cap} tasks reached to avoid flooding. Ask again if you want more.`)
};

const fr_chat_dispatch_cap_reached = /** @type {(inputs: Chat_Dispatch_Cap_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cap de ${i?.cap} tâches atteint pour éviter le flood. Demande encore si tu veux plus.`)
};

const ms_sg2_chat_dispatch_cap_reached = /** @type {(inputs: Chat_Dispatch_Cap_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Had ${i?.cap} tugasan dicapai untuk elak limpahan. Tanya semula jika mahu lagi.`)
};

/**
* | output |
* | --- |
* | "Cap of {cap} tasks reached to avoid flooding. Ask again if you want more." |
*
* @param {Chat_Dispatch_Cap_ReachedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_dispatch_cap_reached = /** @type {((inputs: Chat_Dispatch_Cap_ReachedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dispatch_Cap_ReachedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_dispatch_cap_reached(inputs)
	if (locale === "fr") return fr_chat_dispatch_cap_reached(inputs)
	return ms_sg2_chat_dispatch_cap_reached(inputs)
});